// API URL: always prefer the env var, fall back to localhost for local development
const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const config = { apiUrl };

export default config;
